import { Card, CardContent } from '../ui/card';

export const StatCard = ({ title, value, icon: Icon, bgColor, textColor, index }) => (
    <Card 
        className="stat-card border-0 shadow-sm"
        style={{ animationDelay: `${index * 0.1}s` }}
        data-testid={`stat-card-${index}`}
    >
        <CardContent className="p-6">
            <div className="flex items-center justify-between">
                <div>
                    <p className="text-sm font-medium text-slate-500 mb-1">
                        {title}
                    </p>
                    <p className={`text-2xl font-bold ${textColor}`}>
                        {value}
                    </p>
                </div>
                <div className={`w-12 h-12 rounded-xl ${bgColor} flex items-center justify-center`}>
                    <Icon className={`w-6 h-6 ${textColor}`} />
                </div>
            </div>
        </CardContent>
    </Card>
);

export const StatsGrid = ({ stats, formatCurrency, userRole }) => {
    const statCards = [
        {
            title: 'Total Confirmado',
            value: formatCurrency(stats.total_confirmed),
            icon: require('lucide-react').CheckCircle,
            bgColor: 'bg-green-50',
            textColor: 'text-green-600'
        },
        {
            title: 'Total Pendiente',
            value: formatCurrency(stats.total_pending),
            icon: require('lucide-react').Clock,
            bgColor: 'bg-amber-50',
            textColor: 'text-amber-600'
        },
        {
            title: 'Facturas Confirmadas',
            value: stats.count_confirmed,
            icon: require('lucide-react').FileText,
            bgColor: 'bg-sky-50',
            textColor: 'text-sky-600'
        },
        {
            title: 'Facturas Pendientes',
            value: stats.count_pending,
            icon: require('lucide-react').TrendingUp,
            bgColor: 'bg-purple-50',
            textColor: 'text-purple-600'
        }
    ];

    return (
        <div className="space-y-4">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                {statCards.map((stat, index) => (
                    <StatCard key={stat.title} {...stat} index={index} />
                ))}
            </div>
            {userRole === 'admin' && <ExtraUsersRow stats={stats} formatCurrency={formatCurrency} />}
        </div>
    );
};

const ExtraUsersRow = ({ stats, formatCurrency }) => {
    const { UserPlus } = require('lucide-react');
    const items = [
        { label: 'Confirmado', value: formatCurrency(stats.extra_total_confirmed || 0), color: 'text-fuchsia-700', testid: 'extra-stat-confirmed' },
        { label: 'Pendiente', value: formatCurrency(stats.extra_total_pending || 0), color: 'text-amber-600', testid: 'extra-stat-pending' },
        { label: 'Confirmadas', value: stats.extra_count_confirmed || 0, color: 'text-fuchsia-700', testid: 'extra-stat-count-confirmed' },
        { label: 'Pendientes', value: stats.extra_count_pending || 0, color: 'text-amber-600', testid: 'extra-stat-count-pending' },
    ];
    return (
        <div
            className="rounded-xl border border-fuchsia-200 bg-fuchsia-50/60 px-5 py-4 flex flex-col md:flex-row md:items-center gap-4"
            data-testid="extra-users-stats-row"
        >
            <div className="flex items-center gap-3 md:w-64 shrink-0">
                <div className="w-10 h-10 rounded-xl bg-fuchsia-600 flex items-center justify-center">
                    <UserPlus className="w-5 h-5 text-white" />
                </div>
                <div>
                    <p className="text-sm font-semibold text-fuchsia-800 uppercase tracking-wide">Usuarios Extra (Aparte)</p>
                    <p className="text-xs text-fuchsia-700/70">No suman en las tarjetas de arriba</p>
                </div>
            </div>
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 flex-1">
                {items.map((it) => (
                    <div key={it.label} data-testid={it.testid}>
                        <p className="text-xs text-slate-500">{it.label}</p>
                        <p className={`text-lg font-bold ${it.color}`}>{it.value}</p>
                    </div>
                ))}
            </div>
        </div>
    );
};
